export const OCCURRENCE_ATTACHMENT_MAX_BYTES = 30000000;
export const OCCURRENCE_ATTACHMENT_MAX_MB =
  OCCURRENCE_ATTACHMENT_MAX_BYTES / 1e6;
export const OCCURRENCE_ATTACHMENT_TYPES = [
  "image/png",
  "image/jpeg",
  "application/pdf"
];
export const OCCURRENCE_ATTACHMENT_ACCEPT = OCCURRENCE_ATTACHMENT_TYPES.join(
  ","
);

export function getAttachmentRejection(file) {
  if (!OCCURRENCE_ATTACHMENT_TYPES.includes(file.type)) return "type";
  if (file.size > OCCURRENCE_ATTACHMENT_MAX_BYTES) return "size";
  return null;
}

export const notifyRejectedAttachment = (alert, t) => (file, reason) =>
  alert.show(
    t(
      reason === "size"
        ? "occurrences.attachmentTooLarge"
        : "occurrences.attachmentInvalidType",
      { name: file.name, maxMb: OCCURRENCE_ATTACHMENT_MAX_MB }
    ),
    { title: t("common.actions.error") }
  );

/**
 * Separa os arquivos aceitos e avisa sobre os recusados.
 * @param {FileList|File[]} fileList arquivos escolhidos no input
 * @param {(file: File, reason: "type"|"size") => void} onRejected
 * @returns {File[]} arquivos aceitos
 */
export function filterAllowedAttachments(fileList, onRejected) {
  return Array.from(fileList || []).filter(file => {
    const reason = getAttachmentRejection(file);
    if (reason && onRejected) onRejected(file, reason);
    return !reason;
  });
}
